import {HTMLAttributes} from 'react';
import {requestContext} from '../../../common/requestContext';
import {twMerge} from '../../../common/twMerge';
import {ContentHomeSectionBody} from './ContentHomeSectionBody/ContentHomeSectionBodyMain';
import {ContentHomeSectionHeader} from './ContentHomeSectionHeader/ContentHomeSectionHeaderMain';

function ContentHomeCardSectionMain({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  const {isMobile} = requestContext.requestInfo.display;
  return (
    <div
      className={twMerge(
        'flex w-full flex-col items-center',
        'rounded-12pxr',
        isMobile ? 'bg-theme-solid-10' : 'bg-theme-bg-surface-alt',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export const ContentHomeCardSection = Object.assign(
  ContentHomeCardSectionMain,
  {
    Header: ContentHomeSectionHeader,
    Body: ContentHomeSectionBody,
  }
);
